import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconDelete: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg height={$size} viewBox="0 0 24 24" width={$size} xmlns="http://www.w3.org/2000/svg">
      <path
        d="m22.8 4.80135h-6v-2.00386c-.0586-1.59937-1.4004-2.84979-3-2.79580579h-3.6c-1.59965-.05398001-2.94138 1.19643579-3 2.79580579v2.00386h-6c-.662742 0-1.2.53722-1.2 1.19991.00000003.6627.537258 1.19992 1.2 1.19992h1.2v13.19912c0 1.988 1.61178 3.5997 3.6 3.5997h12c1.9882 0 3.6-1.6117 3.6-3.5997v-13.19912h1.2c.6627 0 1.2-.53722 1.2-1.19992 0-.66269-.5373-1.19991-1.2-1.19991zm-13.2 11.99915c0 .6627-.53726 1.1999-1.2 1.1999s-1.2-.5372-1.2-1.1999v-4.7997c0-.6627.53726-1.1999 1.2-1.1999s1.2.5372 1.2 1.1999zm0-14.00301c0-.19199.252-.39597.6-.39597h3.6c.348 0 .6.20398.6.39597v2.00386h-4.8zm7.2 14.00301c0 .6627-.5373 1.1999-1.2 1.1999s-1.2-.5372-1.2-1.1999v-4.7997c0-.6627.5373-1.1999 1.2-1.1999s1.2.5372 1.2 1.1999z"
        fill="#868e92"
      />
    </svg>
  </IconStyled>
);

IconDelete.defaultProps = iconDefaultProps;
IconDelete.displayName = 'IconDelete';

export default IconDelete;
